import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { injectWorkflowId } from "@utils/parameter-injector";
import { WorkflowChangeRequestResponse } from "@idw-types/data/workflow-change-request";

type ArchiveWorkflowRequestResponse = {
    transferObject: WorkflowChangeRequestResponse;
};

export const archiveWorkflowRequest = async (
    workflowId: string
): Promise<{ data: ArchiveWorkflowRequestResponse; error: any }> => {
    const route = injectWorkflowId(apiRoutes.serviceConfiguration.workflow.archive, workflowId);

    const { data, error } = await handleRequest(RequestTypes.POST, route);
    return { data, error };
};